import React from 'react';
import { Link } from 'react-router-dom';

const AdminDashboard = () => {
  // در حالت واقعی این داده‌ها از API دریافت می‌شوند
  const stats = {
    totalUsers: 1250,
    totalCourses: 48,
    activeOrders: 156,
    totalRevenue: "۱۲۵,۰۰۰,۰۰۰",
    newUsers: 25,
    pendingOrders: 12,
    completedCourses: 156,
    averageRating: 4.5
  };

  return (
    <div className="admin-dashboard">
      {/* خلاصه آمار */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">
            <i className="fa fa-users"></i>
          </div>
          <div className="stat-content">
            <h3>کاربران کل</h3>
            <p>{stats.totalUsers}</p>
            <small className="text-success">
              {stats.newUsers}+ کاربر جدید در این هفته
            </small>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">
            <i className="fa fa-book"></i>
          </div>
          <div className="stat-content">
            <h3>دوره‌های آموزشی</h3>
            <p>{stats.totalCourses}</p>
            <small>میانگین رضایت: {stats.averageRating} از ۵</small>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">
            <i className="fa fa-shopping-cart"></i>
          </div>
          <div className="stat-content">
            <h3>سفارشات فعال</h3>
            <p>{stats.activeOrders}</p>
            <small className="text-warning">
              {stats.pendingOrders} سفارش در انتظار تایید
            </small>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">
            <i className="fa fa-money-bill"></i>
          </div>
          <div className="stat-content">
            <h3>درآمد کل</h3>
            <p>{stats.totalRevenue} تومان</p>
            <small>از ابتدای ماه جاری</small>
          </div>
        </div>
      </div>

      {/* دسترسی سریع */}
      <div className="quick-actions">
        <h2>دسترسی سریع</h2>
        <div className="actions-grid">
          <Link to="/admin/users/add" className="action-card">
            <i className="fa fa-user-plus"></i>
            <span>افزودن کاربر جدید</span>
          </Link>
          
          <Link to="/admin/courses/add" className="action-card">
            <i className="fa fa-plus-circle"></i>
            <span>ایجاد دوره جدید</span>
          </Link>
          
          <Link to="/admin/orders" className="action-card">
            <i className="fa fa-tasks"></i>
            <span>مدیریت سفارشات</span>
          </Link>
          
          <Link to="/admin/settings" className="action-card">
            <i className="fa fa-cog"></i>
            <span>تنظیمات سایت</span>
          </Link>
        </div>
      </div>

      {/* آمار اخیر */}
      <div className="recent-stats">
        <h2>آمار اخیر</h2>
        <div className="stats-table-wrapper">
          <table className="stats-table">
            <thead>
              <tr>
                <th>عنوان</th>
                <th>هفته جاری</th>
                <th>ماه جاری</th>
                <th>تغییرات</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>ثبت نام کاربران</td>
                <td>25</td>
                <td>156</td>
                <td className="text-success">↑ 12%</td>
              </tr>
              <tr>
                <td>فروش دوره‌ها</td>
                <td>48</td>
                <td>245</td>
                <td className="text-success">↑ 8%</td>
              </tr>
              <tr>
                <td>تکمیل دوره‌ها</td>
                <td>36</td>
                <td>189</td>
                <td className="text-warning">↓ 3%</td>
              </tr>
              <tr>
                <td>درآمد (تومان)</td>
                <td>۱۵,۰۰۰,۰۰۰</td>
                <td>۴۵,۰۰۰,۰۰۰</td>
                <td className="text-success">↑ 15%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
